'use client';
import React from 'react';
import TabData from '../TabData';
import { getAssetUrl } from '@utils/getAssetUrl';
import cn from './style.module.scss';

export default function Location(props: any) {
  const { t } = props;
  const tabContent = [
    {
      heading: t['yasTabThreeHeading'],
      description: t['yasTabThreeContent'],
      listElement: t['yasTabThreeElement'],
      images: [{ url: props.themeImg.url }],
    },
    // You can add more tabs with different data here
  ];
  return (
    <div
      className={cn.locationGRDWrapper}
      style={{
        backgroundImage: `url(${props.bgImg.url})`,
      }}
    >
      <TabData tabs={tabContent} />
    </div>
  );
}
